module.exports = __webpack_public_path__ + "static/media/choose.26deda8b.png";